import type { FontValue } from '@elfsight/configurator-contracts';
import { useFontsLoader } from './use-fonts-loader';

type WidgetFontsLoaderProps = {
  fonts: FontValue[];
};

export function WidgetFontsLoader({ fonts = [] }: WidgetFontsLoaderProps) {
  useFontsLoader(fonts);
  return null;
}
